/**
 * @module experience/order-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import { Payment, SwipeData } from '@support/api/proxies/requests/api-2613.interface';

export class PostNegativeFile {
  /**
   * To store payment
   */
  private payment: Payment;
  /**
   * To store swipeData
   */
  private SwipeData: SwipeData;

  constructor(encryptedCard: string) {
    this.setPayment();
    this.setSwipeData(encryptedCard);
  }

  /**
   * Function to set payment
   * @returns Payment
   */
  private setPayment(): void {
    this.payment = {};
    this.payment.programCode = 'U2POSTCNP';
  }

  /**
   * Function to set swipeData
   * @returns swipeData
   */
  private setSwipeData(encryptedCard: string): void {
    this.SwipeData = <SwipeData>{};
    this.SwipeData.encryptedContent = encryptedCard;
  }
}
